import React from 'react';

import Image from '../../../../library/image/image';

import './studded-image.scss';

function StuddedImage() {
  return (
    <Image
      alt="Studded"
      height="24"
      src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/feature-icon_studded-tire.svg"
      styleName="studded-image"
      width="24"
    />
  );
}

export default StuddedImage;
